import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";

import AuthenticatedUser from "./AuthenticatedUser";
import configureAmplify from "./utils/amplifyConfig";
import useImageUploadService from "./Components/Image/useImageUploadService";
import Modal from "./Components/Modal/Modal";
import DashboardLayout from "./Layouts/Dashboard";
import AppInitializer from "./Components/AppInitializer";
import { CommandPalette } from "./Components/CommandPalette";
import { validateAndSaveUrlParams, clearSavedUrlParams } from "./utils/urlParams";
import useInviteFlow from "./hooks/useInviteFlow";
import RouteAnalytics from "./Components/Analytics/RouteAnalytics";

configureAmplify();

// ponytail: deploy marker — first 5 chars of the deployed commit
console.log("[deploy-check] commit", (process.env.REACT_APP_GIT_SHA || "local").slice(0, 5));

function App() {
  useImageUploadService();
  // URL params are saved by useInviteFlow on mount
  useInviteFlow();

  // Clear saved checkout variables from localStorage if no URL parameters
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.toString() === '') {
      clearSavedUrlParams();
      console.log('🧹 App load: No URL parameters detected - cleared saved checkout variables from localStorage');
    }
  }, []);

  // Note: we already call validateAndSaveUrlParams() synchronously above so
  // invite flow can run on first render. No need to call it again here.

  return (
    <div className="App">
      <RouteAnalytics measurementId={process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-M8419FF5W6'} />
      <AuthenticatedUser>
        <AppInitializer>
          <DashboardLayout>
            <Outlet />
          </DashboardLayout>
        </AppInitializer>
      </AuthenticatedUser>
      <Modal />
      <CommandPalette />
    </div>
  );
}

export default App;
